//
//
//
//
//
//
//
//

import qs from 'qs'

export default {
  name: 'app',
  data() {
    return {
      src: 2,            // 2 微信，3无
      isAdmin: false,    // 是否为申诉站长
      url: '',            // 进行申诉的网址
      banKey: ''
    }
  },
  created() {
    this.getQuery()
  },
  methods: {
    getQuery() {
      let {src, bankey} = qs.parse(location.search.slice(1))

      this.src = parseInt(src) || this.$route.query.src || 2

      this.banKey = bankey || this.$route.query.bankey || ''
    },
    ensureIsAdmin() {
      this.isAdmin = true
    },
    handleUrlChange(value) {
      this.url = value
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue